import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import BoxOfficeSalePieChart from "./BoxOfficeSalesPieChart";
import HeatmapChart from "./HeatmapChart";
import ComplimentarySalesColumnChart from "./ComplimentarySalesColumnChart";

export default function PerformanceSales({ data, compChartData }) {
  if (!data) return "";

  let salesData = data.filter((d) => d.boxOffice === true);
  let agents = salesData.map((s) => s?.agent[0]?.email?.split("@")[0]);
  agents = new Set(agents);
  let arr = [];

  for (let agent of agents) {
    arr.push({
      name: agent,
      y: salesData
        .filter((d) => d?.agent[0]?.email?.split("@")[0] === agent)
        .reduce((total, num) => total + num.ticketCounts, 0),
    });
  }

  return (
    <>
      <HeatmapChart data={data} />
      <Row>
        {arr?.length > 0 && (
          <Col xs={data?.length === 0 ? 12 : 6}>
            <BoxOfficeSalePieChart arr={arr} />
          </Col>
        )}
        {compChartData?.length > 0 && (
          <Col xs={arr?.length === 0 ? 12 : 6}>
            <ComplimentarySalesColumnChart data={compChartData} />
          </Col>
        )}
      </Row>
    </>
  );
}
